const MATCH = /[|\\{}()[\]^$+*?.]/g;

export default (str: string): string => {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string.');
  }
  return str.replace(MATCH, '\\$&');
};
